// @ts-nocheck
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import translate from "@insite/client-framework/Translate";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import React, { useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import ShareFill from "@store/Library/Components/Toolkit/Icons/Share/ShareFill";
import { linkGetActionLinkProps } from "@store/Themes/common/props/link";
import sendInvoiceEmail from "@store/Framework/Store/Store/CommonHandlers/SendInvoiceEmail";
import InfosBox from "@store/Library/Components/Toolkit/InfosBox";

interface OwnProps {
    entityId: string;
    extendedStyles?: SendInvoiceEmailButtonStyles;
    variant?: "button" | "clickable";
}

const mapDispatchToProps = {
    sendInvoiceEmail,
};

type Props = OwnProps & ResolveThunks<typeof mapDispatchToProps>;

export interface SendInvoiceEmailButtonStyles {
    button?: ButtonPresentationProps;
    modal?: ModalPresentationProps;
    link?: LinkPresentationProps;
}

export const sendInvoiceEmailButtonStyles: SendInvoiceEmailButtonStyles = {
    button: { variant: "tertiary" },
    link: linkGetActionLinkProps(ShareFill),
    modal: { sizeVariant: "medium" },
};

const invoiceUrl = "/api/v1/invoices/shareinvoice";
const orderUrl = "/api/v1/orders/shareorder";
const SendInvoiceEmailButton = ({ entityId, extendedStyles, sendInvoiceEmail, variant = "button" }: Props) => {
    const [styles] = useState(() => mergeToNew(sendInvoiceEmailButtonStyles, extendedStyles));
    const [modalIsOpen, setModalIsOpen] = useState(false);

    if (!entityId) {
        return null;
    }

    const emailButtonClickHandler = () => {
        sendInvoiceEmail({
            invoiceId: entityId,
            onSuccess: () => {
                setModalIsOpen(true);
            },
            onComplete(resultProps) {
                if (resultProps.apiResult) {
                    // "this" is targeting the object being created, not the parent SFC
                    this.onSuccess?.();
                }
            },
        });
    };

    const modalCloseHandler = () => {
        setModalIsOpen(false);
    };

    return (
        <>
            {variant === "clickable" && (
                <Link {...styles.link} onClick={emailButtonClickHandler} data-test-selector="shareEntity_email">
                    {translate("Send by Email")}
                </Link>
            )}
            {variant === "button" && (
                <Button {...styles.button} onClick={emailButtonClickHandler} data-test-selector="shareEntity_email">
                    {translate("Send by Email")}
                </Button>
            )}
            <Modal
                {...styles.modal}
                headline={translate(`Send by Email`)}
                isOpen={modalIsOpen}
                handleClose={modalCloseHandler}
            >
                <InfosBox type="success">
                    {translate(
                        "Invoice request successful. You will receive this invoice shortly via email. This email will be sent to the email address associated to your user login.",
                    )}
                </InfosBox>
            </Modal>
        </>
    );
};

export default connect(null, mapDispatchToProps)(SendInvoiceEmailButton);
